<template>
  <IconButton
    tag="router-link"
    icon="idownload"
    tooltip="Download & Export"
    outlined
    :to="{
      name: doc.routeNames().export,
      params: { url_slug: doc.url_slug },
    }"
  />
</template>

<script setup lang="ts">
import IconButton from '@/app/components/button/IconButton.vue'

import { DocView } from '@/models/doc'

defineProps<{
  doc: DocView
}>()
</script>
